import { render, staticRenderFns } from "./right-column.vue?vue&type=template&id=51d39f4a&scoped=true&"
import script from "./right-column.vue?vue&type=script&lang=js&"
export * from "./right-column.vue?vue&type=script&lang=js&"
import style0 from "./right-column.vue?vue&type=style&index=0&id=51d39f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d39f4a",
  null
  
)

export default component.exports